document.addEventListener('DOMContentLoaded', () => {
  checkPage()

  function checkPage() {
    const loginContent = document.querySelector('.js-account-login-block')
    const recoverContent = document.querySelector('.js-account-recover-block')
    const recoverSuccessText = document.querySelector(
      '.js-recover-form-success-text'
    )

    if (window.location.href.includes('recover')) {
      loginContent.classList.add('hidden')

      if (recoverSuccessText) {
        document.querySelector('.js-recover-form-title').classList.add('hidden')
        document.querySelector('#recover_password').classList.add('hidden')
        document
          .querySelector('.js-recover-form-success-title')
          .classList.remove('hidden')
      }
      recoverContent.classList.remove('hidden')
    } else if (recoverSuccessText) {
      history.replaceState(null, null, `${location.pathname}?view=recover`)
      checkPage()
    } else {
      loginContent.classList.remove('hidden')
      recoverContent.classList.add('hidden')
    }
  }
})
